'use client';

import { useEffect } from 'react';
import { EAnalytics, ELandingABTest } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';

const AnalyticLandingWrapper = () => {
  const sendEvent = useAnalytics();

  useEffect(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_V,
      params: {
        // eslint-disable-next-line camelcase
        ab_group: ELandingABTest.TEST,
      },
    };

    sendEvent(config);
  }, [sendEvent]);

  return null;
};

export default AnalyticLandingWrapper;
